import React from 'react';
import { motion } from 'framer-motion';
import { Trophy, GraduationCap, Medal, Star } from 'lucide-react';
import PageHeader from '../../components/common/PageHeader';

const CollegeAchievements = () => {
  const achievements = [
    {
      year: '2024',
      title: 'National Science Competition',
      description: 'First place in the National Science Olympiad',
      icon: Trophy,
    },
    {
      year: '2024',
      title: 'WAEC Excellence',
      description: '95% of students achieved 5 credits or more',
      icon: GraduationCap,
    },
    {
      year: '2023',
      title: 'Inter-School Debate',
      description: 'Winners of the Lagos State Debate Championship',
      icon: Medal,
    },
    {
      year: '2023',
      title: 'Sports Day',
      description: 'Overall champions in the Inter-School Athletics Meet',
      icon: Star,
    },
  ];

  const examResults = {
    waec: { year: '2024', passRate: '98%', credits: '95%' },
    neco: { year: '2024', passRate: '97%', credits: '94%' },
  };

  return (
    <>
      <PageHeader
        title="Achievements"
        subtitle="Celebrating excellence and success"
        breadcrumbs={[
          { label: 'Our Schools', href: '/our-schools' },
          { label: 'College', href: '/college' },
          { label: 'Achievements' },
        ]}
      />

      {/* Exam Results */}
      <section className="section-padding bg-primary-600">
        <div className="container-custom">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl md:text-4xl font-display font-bold text-white mb-4">
              Examination Results
            </h2>
            <p className="text-lg text-white/80">
              Our students consistently achieve outstanding results in national examinations.
            </p>
          </motion.div>

          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="bg-white rounded-2xl p-8 text-center"
            >
              <h3 className="text-xl font-bold text-gray-900 mb-4">WAEC {examResults.waec.year}</h3>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <div className="text-4xl font-bold text-primary-600">{examResults.waec.passRate}</div>
                  <div className="text-gray-600">Pass Rate</div>
                </div>
                <div>
                  <div className="text-4xl font-bold text-primary-600">{examResults.waec.credits}</div>
                  <div className="text-gray-600">5+ Credits</div>
                </div>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="bg-white rounded-2xl p-8 text-center"
            >
              <h3 className="text-xl font-bold text-gray-900 mb-4">NECO {examResults.neco.year}</h3>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <div className="text-4xl font-bold text-primary-600">{examResults.neco.passRate}</div>
                  <div className="text-gray-600">Pass Rate</div>
                </div>
                <div>
                  <div className="text-4xl font-bold text-primary-600">{examResults.neco.credits}</div>
                  <div className="text-gray-600">5+ Credits</div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Recent Achievements */}
      <section className="section-padding bg-white">
        <div className="container-custom">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl md:text-4xl font-display font-bold text-gray-900 mb-4">
              Recent Achievements
            </h2>
          </motion.div>

          <div className="max-w-3xl mx-auto space-y-6">
            {achievements.map((achievement, index) => {
              const Icon = achievement.icon;
              return (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: -30 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1 }}
                  className="flex gap-4 bg-gray-50 rounded-xl p-6"
                >
                  <div className="w-12 h-12 bg-gold-100 rounded-xl flex items-center justify-center flex-shrink-0">
                    <Icon className="text-gold-600" size={24} />
                  </div>
                  <div>
                    <span className="text-sm text-primary-600 font-medium">{achievement.year}</span>
                    <h3 className="text-lg font-bold text-gray-900">{achievement.title}</h3>
                    <p className="text-gray-600">{achievement.description}</p>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
};

export default CollegeAchievements;
